import { RegisteredComponent } from "@builder.io/sdk-react";

export const tooltipBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Tooltip",
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderContext: true,
    builderComponents: true,
    builderLinkComponent: true,
  },
  inputs: [
    {
      name: "tooltipText",
      friendlyName: "Tooltip Text",
      type: "uiBlocks",
      defaultValue: [],
    },
    {
      name: "content",
      friendlyName: "Content",
      type: "uiBlocks",
      defaultValue: [],
    },
    {
      name: "position",
      type: "enum",
      enum: ["top", "right", "bottom", "left"],
      defaultValue: "right",
      friendlyName: "Position",
      description: "Position of the tooltip relative to the content",
    },
  ],
};
